import axios from "axios";
import { API_URL } from "../../constants";
import { CompanyHoliday, HolidaySettings } from "./companyHolidays.types";

export async function fetchHolidaySettings(companyId: string): Promise<HolidaySettings> {
  const res = await axios.get(`${API_URL}/${companyId}/holiday-settings`);
  return res.data;
}

export async function fetchCompanyHolidays(
  companyId: string,
  year: number
): Promise<CompanyHoliday[]> {
  const res = await axios.get(`${API_URL}/${companyId}/holidays`, {
    params: { year },
  });
  return res.data.holidays;
}

export async function saveCompanyHoliday(
  companyId: string,
  data: Partial<CompanyHoliday>
): Promise<CompanyHoliday> {
  const res = await axios.post(`${API_URL}/${companyId}/holidays`, data);
  return res.data.holiday;
}


